import {
  Card,
  CardStackSection,
  Heading,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import * as React from "react";
import SuccessIcon from "./SuccessIcon";

type RemoveSupplyPublicFormSuccessProps = {
  bodyText: string;
};

const RemoveSupplyPublicFormSuccess: React.FC<
  RemoveSupplyPublicFormSuccessProps
> = ({ bodyText }) => (
  <CardStackSection>
    <Card>
      {/* Body */}
      <Stack space={["xlarge", "xxlarge"]}>
        {/* Content */}
        <Stack alignX="center">
          <SuccessIcon />
          <Heading variant="h3" align="center">
            Success!
          </Heading>
          <Text align="center">{bodyText}</Text>
        </Stack>
        {/* End Content */}
      </Stack>
      {/* End Body */}
    </Card>
  </CardStackSection>
);

export const RemoveSupplyPublicFormSuccessElectricity = () => (
  <RemoveSupplyPublicFormSuccess
    bodyText={
      "We'll progress with the removal of electricity supply at your property."
    }
  />
);
export const RemoveSupplyPublicFormSuccessGas = () => (
  <RemoveSupplyPublicFormSuccess
    bodyText={"We'll progress with the removal of gas supply at your property."}
  />
);
